import { Link } from 'react-router-dom';

/**
 * Joined destination control for row navigation (not workflow actions).
 * items: [{ to, label, icon, disabled? }]
 */
export function SplitNavControl({ ariaLabel, items = [] }) {
  return (
    <div
      role="group"
      aria-label={ariaLabel}
      className="inline-flex overflow-hidden rounded-full border border-eorig-border bg-white"
      onClick={(event) => event.stopPropagation()}
      onKeyDown={(event) => event.stopPropagation()}
    >
      {items.map((item, index) => {
        const Icon = item.icon;
        const className = `inline-flex items-center gap-1.5 px-2.5 py-1 text-[11px] font-semibold text-eorig-navy-600 transition-colors hover:bg-eorig-navy-600 hover:text-white focus-visible:z-10 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-eorig-cyan/35 ${
          index > 0 ? 'border-l border-eorig-border' : ''
        } ${item.disabled || !item.to ? 'pointer-events-none opacity-40' : ''}`;

        const content = (
          <>
            {Icon ? <Icon className="h-3.5 w-3.5" /> : null}
            {item.label}
          </>
        );

        if (item.disabled || !item.to) {
          return (
            <span key={item.label} className={className} aria-disabled="true">
              {content}
            </span>
          );
        }

        return (
          <Link key={item.label} to={item.to} className={className}>
            {content}
          </Link>
        );
      })}
    </div>
  );
}
